import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { IBillingDocument, IBillingDocumentDetail, IBillingDocumentFilter, IBillingDocumentTypeNames, IBillingDocumentTypes, PaymentMethodTypes } from '../billing-documents.interface';
import { BillingDocumentService } from '../billing-documents.service';
import { Observable, Subscription, debounceTime, distinctUntilChanged, lastValueFrom, of, startWith, switchMap } from 'rxjs';
import { InvoiceStatuses, InvoiceStatusesColors, InvoiceStatusesLabels } from '../billing-documents.constants';
import { BillingDocumentsPDFModalComponent } from '../billing-documents-pdf-modal/billing-documents-pdf-modal.component';
import notify from 'devextreme/ui/notify';
import { Router } from '@angular/router';
import { CorrectiveInvoiceService } from './corrective-invoice.service';
import { ICounter, ICounterFilter } from '../../../counters-page/counters/counters.interface';
import { MyErrorStateMatcher } from '../../../../shared/util/error-state-matcher';
import { ICompany } from '../../../companies-page/companies/companies.interface';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { CompaniesService } from '../../../companies-page/companies/companies.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { CountersService } from '../../../counters-page/counters/counters.service';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { getEmptyDetailItem } from '../../../../shared/components/detail-item/detail-item.interface';
import { CountersModalComponent } from '../../../counters-page/counters/counter-modal/counters-modal.component';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { TaxPercentage } from '../../../../shared/constants/global.constants';
import { roundNum } from '../../../../shared/services/utils.service';
import { CompaniesModalComponent } from '../../../companies-page/companies/companies-modal/companies-modal.component';
import { ClientsModalComponent } from '../../../clients-page/clients/clients-modal/clients-modal.component';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

declare const $: any;
let self: any;

@Component({
  selector: 'app-corrective-invoice-modal',
  templateUrl: './corrective-invoice-modal.component.html',
  styleUrls: ['./corrective-invoice-modal.component.css']
})
export class CorrectiveInvoiceModalComponent implements OnInit {
  @ViewChild('billingDocModal') dialogElement!: ElementRef;
  invoice: IBillingDocument = {};
  correctiveInvoice: IBillingDocument = {};
  readOnly: boolean = false;
  editting: boolean = false;
  dialog: MatDialogRef<any>;
  isDev!: boolean;
  curr!: string;
  hasTermAndCond: boolean = false;
  defaultTermAndCond: string = '';
  form!: UntypedFormGroup;
  saving: boolean = false;
  submitted = false;
  action: string = '';
  filterCounter!: ICounterFilter;
  counters: ICounter[] = [];
  customErrorStateMatcher = new MyErrorStateMatcher();
  subscriptions: Subscription;
  formValueChanged: boolean = false;
  constructedForm: boolean = false;
  refreshPage: boolean = false;
  loading: boolean = false;
  clientsTerm: string = '';
  $clients: Observable<any> = of();

  //comapny
  companyId!: string;
  currentCompany!: ICompany;
  allDataToBilling: boolean = true;

  series: string[] = ['FAC'];
  newSerie: boolean = false;

  invoiceStatuses = InvoiceStatuses;
  invoiceStatusesColors = InvoiceStatusesColors;
  invoiceStatusesLabels = InvoiceStatusesLabels;
  accordionOpenIndexes: number[] = [];

  project!: string;

  billingDocumentTypes = IBillingDocumentTypes;
  billingDocumentTypeNames = IBillingDocumentTypeNames;
  paymentMethodTypes: any; //  = _.cloneDeep(PaymentMethodTypes);
  paymentMethodTypesKeys: any; // = Object.keys(this.paymentMethodTypes);
  paymentNumberTransfer: string = "";


  /*
  //comapny
  companyId: string;
  currentCompany: ICompany;
  allDataToBilling: boolean = true;

  // clients
  $clients: Observable<any> = of();
  clientsTerm: string = '';

  // agreement invoicing
  agreements: IServiceAgreement[] = [];
  agreementsTaskDates: any = {};

  // bulk task invoicing
  tasks: ITask[] = [];

  invoiceStatuses = InvoiceStatuses;
  invoiceStatusesColors = InvoiceStatusesColors;
  invoiceStatusesLabels = InvoiceStatusesLabels;
  invoiceStatusesKeys = Object.keys(InvoiceStatuses);
  redirectToBill = false;
  project: string;
  */

  constructor(
    private _CorrectiveInvoiceService: CorrectiveInvoiceService,
    private _BillingDocumentService: BillingDocumentService,
    public dialogRef: MatDialogRef<any>,
    private _viewContainerRef: ViewContainerRef,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _AuthService: AuthService,
    private _CompaniesService: CompaniesService,
    // public _ClientsService: ClientsService,
    public _SettingsService: SettingsService,
    private fb: UntypedFormBuilder,
    private _AlertService: AlertService,
    // private _TaskHttpService: TaskHttpService,
    private _CountersService: CountersService,
    private _router: Router,
  ) {
    self = this;
    this.dialog = dialogRef;
    this.subscriptions = new Subscription();
  }

  async ngOnInit() {
    this.filterCounter = {
      company: this._AuthService.companyId(),
      filters: {
        id: 'billing_counter',
      },
      sort: '',
      skip: 0,
      limit: 10000
    };
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();

    if ((this.invoice as any)?.correctiveInvoice) {
      this.correctiveInvoice = (this.invoice as any)?.correctiveInvoice;
    }

    /*
    this._SettingsService.getCompanySettingValue(SETTINGS.PAYMENT_OPTIONS)
      .then((el: string) => {
        this.paymentMethodTypes = JSON.parse(el);
        this.paymentMethodTypesKeys = Object.keys(this.paymentMethodTypes);
      });
    */

    //this.form.get('paymentMethodType').setValue('WIRE_TRANSFER');
    // if (this.paymentMethodTypesKeys.includes('TRANSFER')) {
    //   this.form.get('paymentMethodType').setValue('TRANSFER');
    // }

    /*
    this._SettingsService.getCompanySettingValue(SETTINGS.PAYMENT_OPTIONS_WIRE_TRANSFER_ACCOUNT_NUMBER)
      .then((el: string) => {
        this.paymentNumberTransfer = el;
      });
    */

    this.companyId = this._AuthService.companyId();
    this.getCompany();

    this.getCounters().subscribe(() => { });

    await this._SettingsService.getCompanySettingValue(SETTINGS.INVOICE_TERMS_AND_CONDITIONS)
      .then((tc: string) => { this.defaultTermAndCond = tc });

    if (!(self.correctiveInvoice?.details?.length > 0)) this.correctiveInvoice.details = [getEmptyDetailItem()];
    /*
    this.document.details.forEach(detail => {
      if (detail.serviceAgreement ) detail.details = detail.details.length > 0 ? detail.details : [getEmptyDetailItem()]
      if (detail.task) detail.details = detail.details.length > 0 ? detail.details : [getEmptyDetailItem()]
    });
    */

    await this.getInvoice();

    if (this.correctiveInvoice._id) {
      this.editting = true;
      this.action = 'Modificar';
      await this.getCorrectiveInvoice();
      // this.getReceipt();
    }

    else {
      this.invoice.termsAndConditions = this.defaultTermAndCond || ' ';
      this.action = 'Crear';
      await this.buildForm();

      // REFACTOR: Has to wait for the form to be built for the first time
      setTimeout(() => {
        this.constructedForm = true;
      }, 4000);
      // REFACTOR

      // console.log(this.f.paymentMethodType.value)
      // console.log(this.f.paymentMethod.value)
      // this.onPaymentMethodTypeChange(this.f.paymentMethodType.value)
    }

    // disable click outside modal
    self.dialogRef.disableClose = true;
    self.dialogRef.backdropClick().subscribe(() => {
      this.closeModal()
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getStatusColor(status: string): string {
    return this.invoiceStatusesColors[status as keyof typeof this.invoiceStatusesColors] || this.invoiceStatusesColors.ISSUED;
  }
  
  getStatusLabel(status: string): string {
    return this.invoiceStatusesLabels[status as keyof typeof this.invoiceStatusesLabels];
  }

  getCounters(): Observable<void> {
    return new Observable<void>((observer) => {
      this.counters = [];
      this._CountersService.getCountersSeries(this.filterCounter).subscribe((counters) => {
        const filteredCounters = counters.filter((counter: any) => counter.reference_value.serie !== "DRAFT");
        this.counters = _.concat(this.counters, filteredCounters);
        // console.log(this.counters);
        observer.next();
        observer.complete();
      });
    });
  }

  async getCorrectiveInvoice() {
    try {
      const document = await lastValueFrom(this._CorrectiveInvoiceService.getCorrectiveInvoice(this.correctiveInvoice));

      console.log(document);
      this.correctiveInvoice = document;

      await this.buildForm();

      // REFACTOR: Has to wait for the form to be built for the first time
      setTimeout(() => {
        this.constructedForm = true;
      }, 4000);
      // REFACTOR

    } catch (error) {
      console.error('Error fetching corrective invoice:', error);
    }
  }

  async getInvoice() {
    try {
      const document = await lastValueFrom(this._BillingDocumentService.getBillingDocument(this.invoice));

      console.log(document);
      document.status = (document.status || '').replace('PENDING', '');
      this.invoice = document;

    } catch (error) {
      console.error('Error fetching invoice:', error);
    }
  }

  getCompany(reset?: boolean) {
    if (reset) {
      window.scroll(0, 0);
      this.currentCompany = {};
    }
    this._CompaniesService.getCompany(this.companyId).subscribe((company) => {
      this.currentCompany = company;
      if (!this.currentCompany.name || !this.currentCompany.email || !this.currentCompany.phone || !this.currentCompany.taxId) {
        this.allDataToBilling = false;
      } else {
        this.allDataToBilling = true;
      }
    });
  }

  /*
  async getReceipt() {
    const receipt = await this._BillingDocumentService.getReceipt(this.document).toPromise();
    this.document.receipt = receipt ? receipt._id : undefined;
  }
  */

  get f() { return this.form.controls; }
  async buildForm() {
    const currentDate = new Date();
    // const nextMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate());

    // const dueDate = (this.document.dueDate ? new Date(this.document.dueDate).toISOString().substring(0, 10) : nextMonthDate.toISOString().substring(0, 10));

    /*
    console.log()
    const details = (this.document.details || [{ taxPercentage: TaxPercentage, subtotal: 0, tax: 0, total: 0 } as IBillingDocumentDetail])
      .map(detail => {
        const taskDetail = detail.task ? (_.get(detail, 'task.title') || '') + ' (' + (_.get(detail, 'task.category[0].name') || '') + ')' : '';
        const TaxRounded = detail.task ? roundNum(_.get(detail, 'task.tax'), 2) : roundNum(detail.tax, 2);
        const TotalRounded = detail.task ? roundNum(_.get(detail, 'task.total'), 2) : roundNum(detail.total, 2);

        return {
          task: detail.task,
          detail: detail.detail || taskDetail,
          subtotal: detail.subtotal || _.get(detail, 'task.subtotal', 0),
          taxPercentage: detail.taxPercentage || _.get(detail, 'task.taxPercentage', 0),
          tax: TaxRounded || _.get(detail, 'task.tax', 0),
          total: TotalRounded || _.get(detail, 'task.total', 0)
        }
      })
      .map(detail => this.fb.group(detail));
    */

    this.hasTermAndCond = (this.correctiveInvoice.termsAndConditions || '').length > 0;

    const status = this.correctiveInvoice.status ? this.correctiveInvoice.status : this.invoiceStatuses.ISSUED;

    this.form = this.fb.group({
      client: [this.correctiveInvoice.client || this.invoice.client, Validators.compose([Validators.required, clientValidator])],
      serie: [this.correctiveInvoice.serie ?? 'R'],
      date: [new Date(this.correctiveInvoice.date ? this.correctiveInvoice.date : new Date()).toISOString().substring(0, 10)],
      notes: [this.correctiveInvoice.notes || ''],
      termsAndConditions: [this.correctiveInvoice.termsAndConditions || ''],

      subtotal: [this.correctiveInvoice.subtotal || 0],
      tax: [this.correctiveInvoice.tax || 0],
      total: [this.correctiveInvoice.total || 0],
      docNumber: [this.correctiveInvoice.docNumber || this.correctiveInvoice.number || 0],
      status: [status]
    } /*, {
      validators: [
        oneOrMoreDetails()
      ]
    } */ );

    // this.calculateTotals();

    /*
    this.$clients = this.f.client.valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          this.clientsTerm = val;
          return this.filterClients(val || '')
        })
      );
      */

    // if (details.length == 1) this.toggleAccordion(0);
    //console.log(this.f.paymentMethodType)
    //this.onPaymentMethodTypeChange( this.f.paymentMethodType.value)

    if (this.invoice._id) this.f['client'].markAllAsTouched();
    this.subscriptions.add(this.form.valueChanges.subscribe(async event => await this.onFormValueChange(event)));
  }

  async onFormValueChange(event: any) {
    //console.log(this.constructedForm)
    if (this.constructedForm) {
      this.formValueChanged = true;
    }
  }

  notEditableAlert: boolean = false;
  setEditable(value: boolean = true) {
    //console.log(this.document.status);
    if (value && (this.invoice.status == this.invoiceStatuses.CANCELLED)) {
      if (!this.notEditableAlert) {
        this.notEditableAlert = true;
        return this._AlertService.warn("No es posible editar facturas Canceladas");
      }
      else return;
    }
    this.readOnly = !value;
  }

  setTermAndCond() {
    this.hasTermAndCond = !this.hasTermAndCond;
    if (this.hasTermAndCond && !(this.invoice.termsAndConditions || this.f['termsAndConditions'].value)) {
      this.f['termsAndConditions'].setValue(this.defaultTermAndCond);
    }
    if (!this.hasTermAndCond) {
      this.f['termsAndConditions'].setValue("");
    }
  }

  cancelSubmit() {
    if (!this.correctiveInvoice._id) return this.dialog.close();
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(false);
    this.getInvoice();
  }

  /*
  onPaymentMethodTypeChange(selectedMethod?: string) {
    this.form.get('paymentMethod').setValue(selectedMethod === 'WIRE_TRANSFER' ? this.paymentNumberTransfer : '')
  }
  */

  /*
  filterClients(val: string): Observable<any[]> {

    if (typeof val === 'string') {
      return this._ClientsService.getClients({
        sort: 'firstname lastname',
        skip: 0,
        limit: 5000,
        filters: { client: val, isDeleted: false },
        company: this._AuthService.companyId()
      });
    } else {
      return new Observable<any[]>;
    }
  }
    */

  openNewCountersModal() {
    this.openCountersModal({});
  }

  openCountersModal(counter: ICounter, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    config.width = '350px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.counterDialogRef = this._dialog.open(CountersModalComponent, config);
    self.counterDialogRef.componentInstance.readOnly = true;

    self.counterDialogRef.afterClosed().subscribe((result: any) => {
      this.getCounters().subscribe(() => {
        this.f['serie'].setValue(self.counters[this.counters.length - 1].reference_value.serie);
      });
      self.counterDialogRef = null;
    });
  }

  displayClientsFn(client: IClient): string {
    if (client) {
      const firstName = client.firstname?.trim();
      const lastName = client.lastname ? " " + client.lastname.trim() : '';
      return firstName + lastName;
    } else {
      return '';
    }
  }

  clearClient() {
    this.f['client'].setValue(null);
  }

  dueDateChange() {
    console.log(this.f['dueDate'].value);
  }

  /*
  calculateTotals() {
    const details = this.f.details.value;
    let subtotal = 0, tax = 0, total = 0;
    details.forEach((detail: IBillingDocumentDetail) => {
      subtotal += detail.subtotal;
      tax += roundNum(detail.tax);
      total += roundNum(detail.total);
    });
    this.f.subtotal.setValue(subtotal);
    this.f.tax.setValue(tax);
    this.f.total.setValue(total);
  }
  */

  formatDate(date: any) {
    return new Date(date).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  addItem() {
    const details = this.f['details'] as FormArray;
    if (details.controls.every(control => (
      control.value.detail !== '' &&
      control.value.total !== 0
    ))) {
      details.push(this.fb.group({ detail: '', subtotal: 0, taxPercentage: TaxPercentage, tax: 0, total: 0 }));
      // this.calculateTotals();
      // this.toggleAccordion(details.length - 1);
    } else {
      this._AlertService.warn("Para añadir una nueva línea, por favor complete la anterior");
    }
  }

  removeItem(i: number) {
    const details = this.f['details'] as FormArray;
    // this.toggleAccordion(i);
    details.removeAt(i);
    if (details.length == 0) {
      setTimeout(() => {
        details.push(this.fb.group({ detail: '', subtotal: 0, taxPercentage: TaxPercentage, tax: 0, total: 0 }));
        // this.toggleAccordion(0);
      }, 250);
    }
    // this.calculateTotals();
  }

  updateItem(i: number) {
    const details = this.f['details'] as FormArray;
    if (details.at(i) instanceof FormGroup) {
      const currentRow = details.at(i) as FormGroup;

      let taxPercentage = currentRow.get('taxPercentage')?.value;
      let subtotal = currentRow.get('subtotal')?.value;

      const newTax = (taxPercentage * subtotal / 100);
      const newTotal = (subtotal + newTax);

      currentRow.get('tax')?.setValue(String(roundNum(newTax, 2)) || 0);
      currentRow.get('total')?.setValue(String(roundNum(newTotal, 2)) || 0);
    }
    // this.calculateTotals();
  }

  openAccordionItem(index: number) {
    this.accordionOpenIndexes = [index];
  }

  /*
  toggleAccordion(index: number): void {
    const isOpen = this.accordionOpenIndexes.includes(index);
    if (isOpen) this.accordionOpenIndexes = [];
    else this.accordionOpenIndexes = [index];
  }
  */

  scrollDialogToTop() {
    if (this.dialogElement && this.dialogElement.nativeElement) {
      this.dialogElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  taskProductsChange(data: any, item: any) {
    item.controls.task.value.toUpdate = true;
    item.controls.task.value.subtotal = data.subtotal;
    item.controls.task.value.tax = data.tax;
    item.controls.task.value.taxPercentage = data.taxPercentage;
    item.controls.task.value.total = data.total;

    item.controls.subtotal.setValue(data.subtotal);
    item.controls.tax.setValue(data.tax);
    item.controls.taxPercentage.setValue(data.taxPercentage);
    item.controls.total.setValue(data.total);

    // this.calculateTotals();
  }

  async createReceipt() {
    let data: any = _.cloneDeep(this.form.value);
    let body = {
      company: this._AuthService.companyId(),
      client: data.client._id,
      paymentDate: new Date(),
      dueDate: new Date(),
      billingDocument: this.invoice._id,
      total: data.total,
      termsAndConditions: data.termsAndConditions,
      paymentMethod: data.paymentMethod,
      paymentMethodType: data.paymentMethodType
    }
    const receipt = this._BillingDocumentService.createReceipt(body).toPromise();
    return receipt;
  }

  /*
  saveAsDraft() {
    this.f.serie.setValue(this.invoiceStatuses.DRAFT);
    this.f.status.setValue(this.invoiceStatuses.DRAFT);
    this.onSubmit();
  }
    */

  onClientSelectionChange(): void {
    // Aquí puedes manejar el cambio de selección del cliente.
    console.log('Cliente seleccionado:');
  }
  /*
  onClientSelectionChange() {
    this.form.get('client').setErrors({ 'notToBilling': null });
  }
    */


  issueInvoice() {
    if (this.f['serie'].value == this.invoiceStatuses.DRAFT)
      return this._AlertService.warn("Seleccione la serie a utilizar!");
    this.f['status'].setValue(this.invoiceStatuses.ISSUED);
    this.onSubmit(this.invoiceStatuses.ISSUED);
  }


  /*
  setPaidInvoice() {
    // this.f.status.setValue(this.invoiceStatuses.PAID);
    this.onSubmit(this.invoiceStatuses.PAID);
  }
    */

  openCompanyModal(company: ICompany) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '600px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.companyDialogRef = this._dialog.open(CompaniesModalComponent, config);
    self.companyDialogRef.componentInstance.company = company;
    self.companyDialogRef.componentInstance.toBilling = true;
    self.companyDialogRef.componentInstance.readOnly = false;

    self.companyDialogRef.afterClosed().subscribe((result: any) => {
      self.companyDialogRef = null;
      this.getCompany(true);
    });
  }

  openNewClientModal() {
    this.openClientModal({});
  }

  openClientModal(client: IClient) {
    //console.log(client)
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.clientDialogRef = this._dialog.open(ClientsModalComponent, config);
    self.clientDialogRef.componentInstance.client = client;
    self.clientDialogRef.componentInstance.toBilling = true;
    self.clientDialogRef.componentInstance.readOnly = false;

    self.clientDialogRef.afterClosed().subscribe((result: any) => {
      self.clientDialogRef = null;
      if (result) this.f['client'].setValue(result);
    });
  }

  onSubmit(newStatus?: string) {
    let data: any = _.cloneDeep(this.form.value);
    data.details = _.cloneDeep(this.correctiveInvoice.details);

    /*for (let detail of data.details) {
      if (detail.detail && detail.detail.length > 50) {
        return;
      }
      if (detail.description && detail.description.length > 100) {
        return;
      }
    }*/

    // console.log(data)
    // validadores alert
    if (!data.client || !data.serie) {
      this.scrollDialogToTop();
      return this._AlertService.warn("Para crear una factura, debe especificar el cliente / su serie");
    }
    // if (data.subtotal == 0) return this._AlertService.warn("No se permiten Facturas con valor 0");
    if (data.details.filter((el: any) => el.detail == "").length) return this._AlertService.warn("No se permiten detalles vacíos");
    if (!data.details.length) return this._AlertService.warn("Ingrese algun detalle para continuar");
    // if (!(data.subtotal > 0)) return this._AlertService.warn("La Factura debe tener Total mayor o igual a cero");
    // if (!(data.total > 0)) return this._AlertService.warn("La Factura debe tener Total mayor o igual a cero");

    data.details.forEach((det: any) => delete det.serviceAgreement)
    data.details.forEach((det: any) => delete det.task)
    data.details.forEach((det: any) => delete det.product)

    if (!this.allDataToBilling) {
      this._AlertService.warn("Debe completar sus datos fiscales (Nombre, Número de Identificación Fiscal, Dirección, Email y Número de Teléfono)");
      this.openCompanyModal(this.currentCompany);
      return
    }
    if (!data.client.firstname || !data.client.nit || !data.client.taxAddress) {
      this._AlertService.warn("Debe completar los datos fiscales del cliente (Nombre, Número de Identificación Fiscal y Dirección fiscal)");
      this.openClientModal(data.client);
      return
    }

    this.submitted = true;
    if (this.form.invalid) return;

    data.billingDocument = this.correctiveInvoice.billingDocument || this.invoice._id;

    if (this.project) data.project = this.project;

    let isNewBillDoc = this.action === 'Crear' ? true : false

    const modalOptions: IConfirmationDialogOptions = {
      title: "Guardar Factura",
      message: (isNewBillDoc ? 'IMPORTANTE: Cuando se cree la factura, se guardará de forma segura.\nEste proceso no puede revertirse y los cambios que podrán realizarse en la factura serán limitados.' : 'Está seguro que desea Guardar esta Factura?'),
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe(async (confirmation: any) => {
        if (confirmation) {
          this.saving = true;
          data.company = this._AuthService.companyId();

          if (this.formValueChanged) {
            this.refreshPage = true;
          }

          // REFACTOR
          let date = data.date ?
            data.date.substring(0, 10) + 'T12:00:00.000Z' :
            new Date().toISOString().substring(0, 10) + 'T12:00:00.000Z';

          /*
          let dueDate = data.dueDate ?
            data.dueDate.substring(0, 10) + 'T12:00:00.000Z' :
            new Date().toISOString().substring(0, 10) + 'T12:00:00.000Z';
          */

          let invoiceData: IBillingDocument = {
            company: this._AuthService.companyId(),
            client: data.client._id,
            date: date,
            // dueDate: dueDate,
            billingDocument: data.billingDocument?._id || data.billingDocument,

            subtotal: data.subtotal,
            tax: data.tax,
            taxPercentage: data.taxPercentage,
            total: data.total,

            details: [],

            project: data.project,
            notes: data.notes,
            termsAndConditions: data.termsAndConditions,
            serie: data.serie,
            paymentMethod: data.paymentMethod,
            paymentMethodType: data.paymentMethodType,

            status: data.status
          };

          for (const detail of data.details) {
            invoiceData.details?.push(detail);

            // console.log(detail.task);

            /*
            if (_.get(detail, 'task.toUpdate')) {
              const data = {
                _id: detail.task._id,
                company: detail.task.company._id,
                // products: [],
                subtotal: detail.task.subtotal,
                tax: detail.task.tax,
                taxPercentage: detail.task.taxPercentage,
                total: detail.task.total,
              }
                */
            /*
            data.products = detail.task.products.map(item => {
              return { product: item.product._id, name: item.name, quantity: item.quantity, price: item.price }
            });
            */
            // await this._TaskHttpService.updateTask(data).toPromise();
            // }

            // try { detail.task = detail.task._id; } catch (e) { }

            /* if (!(detail.subtotal === 0 && detail.taxPercentage === 0 && (!detail.detail || detail.detail === ""))) {
              invoiceData.details.push(detail);
            } */
          }

          // revisar esto !!!
          if (this.correctiveInvoice._id) {
            invoiceData._id = this.correctiveInvoice._id;
            // const method = newStatus == this.invoiceStatuses.ISSUED ? 'issueInvoiceDocument' : 'updateBillingDocument';
            this._CorrectiveInvoiceService.updateCorrectiveInvoice(invoiceData).subscribe({
              next: async (doc) => {
                // if (newStatus == this.invoiceStatuses.PAID) await this.createReceipt();
                this.submitted = false;
                this.saving = false;
                this.setEditable(false);
                this.getCorrectiveInvoice();
                // this.getReceipt();
                if (newStatus) this.dialog.close(doc);
              },
              error: () => this.saving = false
            });
          }

          else {
            console.log(invoiceData)
            this._CorrectiveInvoiceService.createCorrectiveInvoice(invoiceData).subscribe({
              next: (doc) => {
                /* if (this.redirectToBill) {
                  this._router.navigate(['/admin', this._AuthService.companyIndex(), 'billing-documents']).then(() => {
                    window.location.reload();
                  });
                } else { */
                this.correctiveInvoice._id = doc._id;
                this.submitted = false;
                this.saving = false;
                this.setEditable(false);
                this.dialog.close(doc);
                this.action = 'Modificar';
                this.getCorrectiveInvoice();
                // }
              },
              error: () => this.saving = false
            });
          }
        }
      });
  }

  openDocument() {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.correctiveInvoice = this.correctiveInvoice;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  openDocumentOriginal() {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsPDFModalComponent, config);
    if(this.action === 'Crear'){
      self.pdfDialogRef.componentInstance.document = this.invoice;
    }else{
      self.pdfDialogRef.componentInstance.document = this.correctiveInvoice.billingDocument;
    }

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  cancelBtnHover = false;

  toggleCancelBtnHover(isHovering: boolean): void {
    this.cancelBtnHover = isHovering;
  }

  /*
  downloadReceipt() {
    const name = `Recibo de Factura ${this.invoice.serieAndNumber} de ${this._AuthService.company().name}`;
    const id = this.invoice.receipt._id ? this.invoice.receipt._id : this.invoice.receipt;
    this._BillingDocumentService.downloadReceipt(id, name);
  }
    */

  download() {
    const name = `Factura Rectificadora ${this.correctiveInvoice.serie + '000' + this.correctiveInvoice.number} de ${this._AuthService.company().name}`;
    this._CorrectiveInvoiceService.download(this.correctiveInvoice._id || '', name);
  }

  sendEmail() {
    if ((this.invoice.client as any).emails.length > 0) {

      const modalOptions: IConfirmationDialogOptions = {
        title: "Enviar por email",
        message: "¿Desea enviar la factura a la siguiente dirección? " + (this.invoice.client as any).emails[0].address,
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };

      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            let data = {};
            this._CorrectiveInvoiceService.sendEmail(this.correctiveInvoice._id, data).subscribe((result: any) => {
              result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
            });
          }
        });
    } else {
      this._AlertService.warn("El cliente no tiene un email cargado");
    }
  }

  /*
  removePaymentsInvoice() {
    let data: any = _.cloneDeep(this.form.value);

    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Pago",
      message: "Si elimina el pago, la factura dejará de estar en estado “Pagada”.",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._BillingDocumentService.deleteReceipt(this.invoice.receipt).subscribe(result => {
            this._BillingDocumentService.updateBillingDocument({
              _id: this.invoice._id, status: this.invoiceStatuses.ISSUED
            }).subscribe(result => {
              this.dialog.close();
            });
          });
        }
      });
  }
  */

  /*
  cancelDocument() {
    let data: any = _.cloneDeep(this.form.value);
    data.details = _.cloneDeep(this.invoice.details);
    const includeTasks = data.details.filter(el => el.task ? true : false).length > 0;
    const isPaid = this.invoice.status == this.invoiceStatuses.PAID;

    const modalOptions: IConfirmationDialogOptions = {
      title: "Cancelar Factura",
      message: "Está seguro que desea Cancelar esta Factura? " +
        (includeTasks ? 'Todos los trabajos incluidos en ella volverán a estado “Completado”. ' : '') +
        (isPaid ? 'Se eliminará su recibo de pago ' : ''),
      yesButtonLabel: 'Eliminar Factura', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          if (isPaid)
            this._BillingDocumentService.deleteReceipt(this.invoice.receipt).subscribe(result => {
              this._BillingDocumentService.cancelBillingDocument(this.invoice).subscribe(result => {
                this.dialog.close();
              });
            });
          else
            this._BillingDocumentService.cancelBillingDocument(this.invoice).subscribe(result => {
              this.dialog.close();
            });
        }
      });
  }
  */

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  /*----------------- Detail ------------------*/
  onListChange(event: any) {
    // console.log(event);
    // this.f.details.setValue(event.items);
    this.f['subtotal'].setValue(event.totals.subtotal);
    this.f['tax'].setValue(event.totals.tax);
    this.f['total'].setValue(event.totals.total);
  }

  confirmExit() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Salir",
      message: "¿Está seguro de que desea salir? Los cambios no se guardarán",
      yesButtonLabel: 'Sí, deseo salir',
      noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          self.dialogRef.close();
        }
      });
  }

  closeModal() {
    if (!this.readOnly && this.formValueChanged) {
      this.confirmExit()
    } else {
      if (this.refreshPage) {
        self.dialogRef.close(this.invoice);
      } else {
        self.dialogRef.close();
      }
    }
  }
}

function clientValidator(control: AbstractControl): any {
  control.setErrors(null);
  if (control.value) {
    if (!_.get(control.value, '_id')) return { notFound: true };
    if (!_.get(control.value, 'firstname') || !_.get(control.value, 'nit') || !_.get(control.value, 'taxAddress')) return { notToBilling: true };
  }
}

function oneOrMoreDetails() {
  return (group: UntypedFormGroup) => {
    let detailsControl = group.controls['details'];
    if (!detailsControl.value.length) detailsControl.setErrors({ emptyDetails: true })
  }


}